require('./bootstrap');
import 'jquery-ui/ui/widgets/datepicker.js';
require('./img-uploader');